import { gql } from '@apollo/client'

export const SEND_CASE_EMAIL_MUTATION = gql`
  mutation sendCaseEmail(
    $caseId: ID!
    $toAddresses: [String!]!
    $subject: String!
    $bodyHtml: String!
    $ccAddresses: [String!]
    $bccAddresses: [String!]
    $processingId: ID
    $draftId: ID
    $replyToEmailId: ID
    $attachmentBlobIds: [String!]
    $removeAttachmentIds: [ID!]
  ) {
    sendCaseEmail(
      caseId: $caseId
      toAddresses: $toAddresses
      subject: $subject
      bodyHtml: $bodyHtml
      ccAddresses: $ccAddresses
      bccAddresses: $bccAddresses
      processingId: $processingId
      draftId: $draftId
      replyToEmailId: $replyToEmailId
      attachmentBlobIds: $attachmentBlobIds
      removeAttachmentIds: $removeAttachmentIds
    ) {
      caseEmail {
        id
        direction
        status
        subject
        bodyHtml
        fromAddress
        fromName
        toAddresses
        ccAddresses
        bccAddresses
        sentAt
        createdAt
      }
      errors
    }
  }
`
